var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayersDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6412 10.9084L12.1456 14.4837C12.0528 14.5242 11.9473 14.5242 11.8545 14.4837L4.35889 10.9084",
    stroke: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6412 13.0916L12.1456 16.6669C12.0528 16.7074 11.9473 16.7074 11.8545 16.6669L4.35889 13.0916",
    stroke: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6412 15.2748L12.1456 18.8501C12.0528 18.8906 11.9473 18.8906 11.8545 18.8501L4.35889 15.2748",
    stroke: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1457 12.3005C12.0529 12.341 11.9474 12.341 11.8546 12.3005L4.39904 9.05851C4.26667 9.00053 4.18115 8.86972 4.18115 8.72521C4.18115 8.5807 4.26667 8.44988 4.39904 8.39191L11.8546 5.14988C11.9474 5.10938 12.0529 5.10938 12.1457 5.14988L19.6013 8.39191C19.7336 8.44988 19.8192 8.5807 19.8192 8.72521C19.8192 8.86972 19.7336 9.00053 19.6013 9.05851L12.1457 12.3005Z",
    stroke: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayersDark);
export default __webpack_public_path__ + "static/media/layers-dark.3ad77f279809c4e3021fa2b36ae9b8a0.svg";
export { ForwardRef as ReactComponent };